// extracted by mini-css-extract-plugin
export default {"empty":"empty_empty__kd9g1","img":"empty_img__05OLb","text":"empty_text__Rwdc1","rotate":"empty_rotate__InQfO"};